// Dictionary — game/misc.cpp:1560-1715. A MOVE-TO-FRONT singly-linked list with
// C-locale case-INSENSITIVE keys (Find uses stricmp, misc.cpp:1704-1715). BOTH Get
// (misc.cpp:1600-1615) and Set (misc.cpp:1617-1645) relink the touched entry at the
// HEAD, and SaveState walks head-first — so the serialized pvar ORDER encodes the
// touch history (most-recently-used first). Reads reorder the dictionary: even a
// TestPvar trigger condition changes the next save's bytes. LoadState appends
// tail-wise (misc.cpp:1661-1687), so a loaded dictionary is in file order until the
// first touch. A plain insertion-ordered Map is NOT byte-compatible (caught by code
// review of the savegame cross-validation work).

function asciiFold(s: string): string {
  let out = '';
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    out += String.fromCharCode(c >= 0x41 && c <= 0x5a ? c + 0x20 : c);
  }
  return out;
}

interface DictEntry {
  name: string;
  value: string;
}

export class Dictionary {
  private entries: DictEntry[] = []; // index 0 = list head (MRU)

  private find(name: string): number {
    const want = asciiFold(name);
    for (let i = 0; i < this.entries.length; i++) {
      if (asciiFold(this.entries[i].name) === want) return i;
    }
    return -1;
  }

  /** misc.cpp:1600-1615 — a successful Get RELINKS the entry at the head. */
  Get(name: string): string | null {
    const i = this.find(name);
    if (i < 0) return null;
    const e = this.entries[i];
    if (i > 0) {
      this.entries.splice(i, 1);
      this.entries.unshift(e);
    }
    return e.value;
  }

  /** misc.cpp:1617-1645 — Set rewrites name+value and links the entry at the head
   *  (an existing entry found case-insensitively is reused, its stored name updated). */
  Set(name: string, value: string): boolean {
    const i = this.find(name);
    let e: DictEntry;
    if (i >= 0) {
      e = this.entries[i];
      this.entries.splice(i, 1);
    } else {
      e = { name: '', value: '' };
    }
    e.name = name;
    e.value = value;
    this.entries.unshift(e);
    return true;
  }

  get size(): number {
    return this.entries.length;
  }

  Clear(): void {
    this.entries.length = 0;
  }

  /** SaveState walk order: head-first (misc.cpp:1689-1702). */
  entriesInOrder(): readonly DictEntry[] {
    return this.entries;
  }

  /** LoadState appends tail-wise (misc.cpp:1661-1687) — preserves file order. */
  Append(name: string, value: string): void {
    this.entries.push({ name, value });
  }
}
